import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成

import { getAuthorityList, deleteAuthority, createAuthority, updateAuthority, copyAuthority, returnMerchantGrade } from '@/api/authority';
import Menus from '@/view/superAdmin/authority/components/menus';
import Apis from '@/view/superAdmin/authority/components/apis';
import Datas from '@/view/superAdmin/authority/components/datas';
import infoList from '@/mixins/infoList';
export default {
  name: 'Authority',
  components: {
    Menus: Menus,
    Apis: Apis,
    Datas: Datas
  },
  mixins: [infoList],
  data: function data() {
    var mustUint = function mustUint(rule, value, callback) {
      if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
        return callback(new Error('请输入正整数'));
      }
      return callback();
    };
    return {
      AuthorityOption: [{
        authorityId: '0',
        authorityName: '根角色'
      }],
      listApi: getAuthorityList,
      drawer: false,
      dialogType: 'add',
      activeRow: {},
      activeUserId: 0,
      dialogTitle: '新增角色',
      dialogFormVisible: false,
      apiDialogFlag: false,
      copyForm: {},
      form: {
        authorityId: '',
        authorityName: '',
        parentId: '0',
        merchantGrade: 2
      },
      merchant: '',
      merchantLevel: {},
      rules: {
        authorityId: [{
          required: true,
          message: '请输入角色ID',
          trigger: 'blur'
        }, {
          validator: mustUint,
          trigger: 'blur'
        }],
        authorityName: [{
          required: true,
          message: '请输入角色名',
          trigger: 'blur'
        }],
        parentId: [{
          required: true,
          message: '请选择请求方式',
          trigger: 'blur'
        }],
        merchantGrade: [{
          required: true,
          message: '请选择商户等级',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.pageSize = 999;
            _context.next = 1;
            return _this.getTableData();
          case 1:
            _context.next = 2;
            return _this.getMerchantGrade();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    autoEnter: function autoEnter(activeName, oldActiveName) {
      var paneArr = ['menus', 'apis', 'datas'];
      if (oldActiveName) {
        if (this.$refs[paneArr[oldActiveName]].needConfirm) {
          this.$refs[paneArr[oldActiveName]].enterAndNext();
          this.$refs[paneArr[oldActiveName]].needConfirm = false;
        }
      }
    },
    // 获取商户等级
    getMerchantGrade: function getMerchantGrade() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return returnMerchantGrade();
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.merchantLevel = res.data;
                _this2.merchant = res.data[2];
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 拷贝角色
    copyAuthority: function copyAuthority(row) {
      this.setOptions();
      this.dialogTitle = '拷贝角色';
      this.dialogType = 'copy';
      for (var k in this.form) {
        this.form[k] = row[k];
      }
      this.copyForm = row;
      this.dialogFormVisible = true;
    },
    opdendrawer: function opdendrawer(row) {
      this.drawer = true;
      this.activeRow = row;
    },
    // 删除角色
    deleteAuth: function deleteAuth(row) {
      var _this3 = this;
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return deleteAuthority({
                authorityId: row.authorityId
              });
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                if (_this3.tableData.length === 1 && _this3.page > 1) {
                  _this3.page--;
                }
                _this3.getTableData();
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 初始化表单
    initForm: function initForm() {
      if (this.$refs.authorityForm) {
        this.$refs.authorityForm.resetFields();
      }
      this.form = {
        authorityId: '',
        authorityName: '',
        parentId: '0'
      };
    },
    // 关闭窗口
    closeDialog: function closeDialog() {
      this.initForm();
      this.dialogFormVisible = false;
      this.apiDialogFlag = false;
    },
    // 确定弹窗
    enterDialog: function enterDialog() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(_this4.form.authorityId === '0')) {
                _context5.next = 1;
                break;
              }
              _this4.$message({
                type: 'error',
                message: '角色id不能为0'
              });
              return _context5.abrupt("return", false);
            case 1:
              _this4.$refs.authorityForm.validate(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(valid) {
                  var res, _res, data, _res2, _t;
                  return regeneratorRuntime.wrap(function (_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!valid) {
                          _context4.next = 8;
                          break;
                        }
                        _t = _this4.dialogType;
                        _context4.next = _t === 'add' ? 1 : _t === 'edit' ? 3 : _t === 'copy' ? 5 : 7;
                        break;
                      case 1:
                        _context4.next = 2;
                        return createAuthority(_this4.form);
                      case 2:
                        res = _context4.sent;
                        if (res.code === 0) {
                          _this4.$message({
                            type: 'success',
                            message: '添加成功!'
                          });
                          _this4.getTableData();
                          _this4.closeDialog();
                        }
                        return _context4.abrupt("continue", 7);
                      case 3:
                        _context4.next = 4;
                        return updateAuthority(_this4.form);
                      case 4:
                        _res = _context4.sent;
                        if (_res.code === 0) {
                          _this4.$message({
                            type: 'success',
                            message: '添加成功!'
                          });
                          _this4.getTableData();
                          _this4.closeDialog();
                        }
                        return _context4.abrupt("continue", 7);
                      case 5:
                        data = {
                          authority: {
                            authorityId: 'string',
                            authorityName: 'string',
                            datauthorityId: [],
                            parentId: 'string'
                          },
                          oldAuthorityId: 0
                        };
                        data.authority.authorityId = _this4.form.authorityId;
                        data.authority.authorityName = _this4.form.authorityName;
                        data.authority.parentId = _this4.form.parentId;
                        data.authority.dataAuthorityId = _this4.copyForm.dataAuthorityId;
                        data.oldAuthorityId = _this4.copyForm.authorityId;
                        _context4.next = 6;
                        return copyAuthority(data);
                      case 6:
                        _res2 = _context4.sent;
                        if (_res2.code === 0) {
                          _this4.$message({
                            type: 'success',
                            message: '复制成功！'
                          });
                          _this4.getTableData();
                        }
                      case 7:
                        _this4.initForm();
                        _this4.dialogFormVisible = false;
                      case 8:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    setOptions: function setOptions() {
      this.AuthorityOption = [{
        authorityId: '0',
        authorityName: '根角色'
      }];
      this.setAuthorityOptions(this.tableData, this.AuthorityOption, false);
    },
    setAuthorityOptions: function setAuthorityOptions(AuthorityData, optionsData, disabled) {
      var _this5 = this;
      this.form.authorityId = String(this.form.authorityId);
      AuthorityData && AuthorityData.map(function (item) {
        if (item.children && item.children.length) {
          var option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName,
            disabled: disabled || item.authorityId === _this5.form.authorityId,
            children: []
          };
          _this5.setAuthorityOptions(item.children, option.children, disabled || item.authorityId === _this5.form.authorityId);
          optionsData.push(option);
        } else {
          var _option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName,
            disabled: disabled || item.authorityId === _this5.form.authorityId
          };
          optionsData.push(_option);
        }
      });
    },
    // 增加角色
    addAuthority: function addAuthority(parentId) {
      this.initForm();
      this.dialogTitle = '新增角色';
      this.dialogType = 'add';
      this.form.parentId = parentId;
      this.form.merchantGrade = 2;
      this.setOptions();
      this.getMerchantGrade();
      this.dialogFormVisible = true;
    },
    // 编辑角色
    editAuthority: function editAuthority(row) {
      this.setOptions();
      this.dialogTitle = '编辑角色';
      this.dialogType = 'edit';
      for (var key in this.form) {
        this.form[key] = row[key];
      }
      this.merchant = this.merchantLevel[row.merchantGrade];
      this.setOptions();
      this.dialogFormVisible = true;
    }
  }
};